import { OrderBookType } from '../../config/constants';

const isClosePositionOrder = (
    orderType: OrderBookType
): orderType is OrderBookType.CLOSE => {
    return [OrderBookType.CLOSE].includes(orderType);
};

export default isClosePositionOrder;
